import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { BackendPlan, PaymentBackendParams, PaymentBackendResponse, ReduxEntity } from 'Douleutaras/types';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { RootState } from 'Douleutaras/redux/store';

const BACKEND_ENDPOINT = 'api/public/backend';

const paymentBackendAdapter = createEntityAdapter<BackendPlan>({
  selectId: p => p.id
});

export const getBackend = createAsyncThunk<PaymentBackendResponse, { backend: string; params: PaymentBackendParams }>(
  'settings/backend/get',
  async ({ backend, params }, api) => {
    const response = await makeRequest(
      `${BACKEND_ENDPOINT}/${backend}/`,
      {
        method: 'GET',
        additionalGetParams: params
      }
    )(api);

    return response.data;
  }
);

export const getBackends = createAsyncThunk<Array<BackendPlan>, void>(
  'settings/backends/get',
  async (args, api) => {
    const res = await makeRequest(BACKEND_ENDPOINT)(api);

    return res.data.map((backend, key) => ({
      ...backend,
      slug: backend.id,
      id: key
    }));
  }
);

export const paymentBackendSlice = createSlice({
  name: 'paymentBackend',
  initialState: paymentBackendAdapter.getInitialState({
    loading: false,
    error: false,
    entities: []
  } as ReduxEntity<BackendPlan>),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getBackend.pending, state => {
      state.loading = true;
    });
    builder.addCase(getBackend.fulfilled, state => {
      state.loading = false;
    });
    builder.addCase(getBackends.pending, state => {
      state.loading = true;
    });
    builder.addCase(getBackends.fulfilled, (state, action) => {
      state.loading = false;
      paymentBackendAdapter.setMany(state, action.payload);
    });
  }
});

export const paymentBackendSelector = paymentBackendAdapter.getSelectors<RootState>(state => state.paymentBackend);
